<div class="alert alert-{{type}} no-margin" role="alert" >
    {{message}}
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>